import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { LoginComponent } from './auth/login/login.component';
import { LogoutComponent } from './auth/logout/logout.component';
import { ContactUsComponent } from './components/contact/contact-us/contact-us.component';
import { DebtSummaryComponent } from './components/debt/debt-summary/debt-summary.component';
import { ErrorComponent } from './components/error/error.component';
import { PayByArrangementComponent } from './components/payment/pay-by-arrangement/pay-by-arrangement.component';
import { PayInFullComponent } from './components/payment/pay-in-full/pay-in-full.component';
import { PaymentSuccessfulComponent } from './components/payment/payment-successful/payment-successful.component';
import { PaymentProcessComponent } from './components/payment/payment-process/payment-process.component';

const routes: Routes = [
  { path: 'debt/summary', component: DebtSummaryComponent, canActivate: [AuthGuard] },
  { path: 'payment/payinfull', component: PayInFullComponent, canActivate: [AuthGuard] },
  { path: 'payment/paybyarrangement', component: PayByArrangementComponent, canActivate: [AuthGuard]  },
  { path: 'payment/success/:type', component: PaymentSuccessfulComponent },
  { path: 'payment/process/:type', component: PaymentProcessComponent },
  { path: 'contact', component: ContactUsComponent, canActivate: [AuthGuard]  },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent, canActivate: [AuthGuard]  },
  { path: 'error', component: ErrorComponent },
  {
    path: '',
    redirectTo: '/debt/summary',
    pathMatch: 'full'
  },
  { path: '**', redirectTo: '/debt/summary' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
